import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { IAddReportNotesRequest, IAddReportNotesResponse, IGetAllReportsResponse, IUpdateReportStatusRequest, IUpdateReportStatusResponse } from "../../../_models/voilation-reports.model";

@Injectable({
  providedIn: "root",
})
export class VoilationReportService {

  private readonly endpoint = 'admin';

  constructor(private apiService: ApiService) { }

  getStats() {
    return this.apiService.get<any>({ Url: `${this.endpoint}/stats` });
  }

  getReports(params: {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: string;
    status?: string;
    reportReason?: string;
    search?: string;
    includeDeleted?: boolean;
  }) {

    const query = new URLSearchParams();

    if (params.page) query.append('page', params.page.toString());
    if (params.limit) query.append('limit', params.limit.toString());
    if (params.sortBy) query.append('sortBy', params.sortBy);
    if (params.sortOrder) query.append('sortOrder', params.sortOrder);
    if (params.status) query.append('status', params.status);
    if (params.reportReason) query.append('reportReason', params.reportReason);
    if (params.search) query.append('search', params.search);
    if (params.includeDeleted) query.append('includeDeleted', 'true');

    return this.apiService.get<IGetAllReportsResponse>({
      Url: `${this.endpoint}/reports?${query.toString()}`
    });
  }

  updateStatus(reportId: string, body: IUpdateReportStatusRequest) {
    return this.apiService.put<IUpdateReportStatusRequest, IUpdateReportStatusResponse>({
      Url: `${this.endpoint}/reports/${reportId}/status`,
      Body: body
    });
  }

  addNotes(reportId: string, body: IAddReportNotesRequest) {
    return this.apiService.put<IAddReportNotesRequest, IAddReportNotesResponse>({
      Url: `${this.endpoint}/reports/${reportId}/notes`,
      Body: body
    });
  }

  bulkDelete(reportIds: string[]) {
    return this.apiService.delete<{ reportIds: string[] }, any>({
      Url: `${this.endpoint}/reports/bulk`,
      Body: { reportIds }
    });
  }
}

